import _formatUtils from './formatUtils';
import _mathUtils from './mathUtils';
import _treeUtils from './treeUtils';

// export const sha256 = require('crypto-js/sha256')
// export const md5 = require('crypto-js/md5')

export const formatUtils = _formatUtils;
export const mathUtils = _mathUtils;
export const treeUtils = _treeUtils;

export const objectPath = require('object-path');
export const shortid = require('shortid');

/**
 * 是否是IOS
 * @returns boolean
 */
export const isIOS = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(userAgent)) {
    return true;
  } else if (userAgent.includes('android')) {
    return false;
  }
  return false;
};
/**
 * 是否是mac
 * @returns boolean
 */
export const isMac = (): boolean => {
  return /macintosh|mac os x/i.test(navigator.userAgent);
};
/**
 * 是否是Edge
 * @returns
 */
export const isEdge = (): boolean => {
  return /Edg/i.test(navigator.userAgent);
};

/**
 * 获取平台系统 返回 android/ipad/iphone/mac/windows
 * @returns android/ipad/iphone/mac/windows
 */
export const getSystem = (): string => {
  const userAgent: string = navigator.userAgent.toLocaleLowerCase();
  let s: string = '';
  if (userAgent.search(/android/i) > 0) {
    s = 'android';
  } else if (userAgent.search(/ipad/i) > 0) {
    s = 'ipad';
  } else if (userAgent.search(/iphone/i) > 0) {
    s = 'iphone';
  } else if (userAgent.search(/macintosh/i) > 0) {
    s = 'mac';
  } else if (userAgent.search(/windows/i) > 0) {
    s = 'windows';
  }
  return s;
};

/**
 * 获取浏览器类型
 * @returns 返回  Opera/FF/Chrome/Safari/Edge/IE
 */
export const getBrowser = (): string => {
  const userAgent = navigator.userAgent;
  let browserType = '';
  if (userAgent.indexOf('Opera') > -1) {
    browserType = 'Opera';
  } else if (userAgent.indexOf('Firefox') > -1) {
    browserType = 'FF';
  } else if (/Edg/i.test(navigator.userAgent)) {
    browserType = 'Edge';
  } else if (userAgent.indexOf('Chrome') > -1) {
    browserType = 'Chrome';
  } else if (userAgent.indexOf('Safari') > -1) {
    browserType = 'Safari';
  } else if (!!(window as any).ActiveXObject || 'ActiveXObject' in window) {
    browserType = 'IE';
  }
  return browserType;
};
/**
 * copy指定文本
 * @param str
 * @returns
 */
export const copyText = (str: string) => {
  try {
    const input = document?.createElement('textarea');
    input.value = str;
    input.style.width = '0';
    input.style.height = '0';
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    return true;
  } catch (e) {
    return false;
  }
};
/**
 * 是否是file协议
 */
export const isFileProtocol = (): boolean => {
  return window.location.protocol === 'file:';
};

/**
 * 获取url的参数
 * @param url
 * @param name
 * @returns
 */
export const getQueryParam = (url: string, name: string) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = url.substr(url.indexOf('?') + 1).match(reg);
  if (r !== null) return unescape(r[2]);
  return null;
};
/**
 * 获取url的全部参数
 * @param url
 * @returns
 */
export const getQueryParamAll = (url: string) => {
  const urlStr = url.split('?')[1]
  const obj:any = {};
  if (urlStr) {
    const paramsArr = urlStr.split('&')
    for (let i = 0, len = paramsArr.length; i < len; i++) {
    // 再通过 = 将每一个参数分割为 key:value 的形式
      const arr = paramsArr[i].split('=')
      obj[arr[0]] = arr[1];
    }
  }
  return obj
};
/**
 * 拼接URL
 * @param url url
 * @param obj 拼接对象
 * @returns  拼接后的url
 * @description: setUrlParams('https://baidu.com?a=1', {b:2,c:3}) return 'https://baidu.com?a=1&b=2&c=3'
 */
export const setUrlParams = (url: string, obj: { [key: string]: any }) => {
  const params = [];
  for (const key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      params.push(`${key}=${obj[key]}`);
    }
  }
  if (url.indexOf('?') > -1) {
    return (url += '&' + params.join('&'));
  } else {
    return (url += '?' + params.join('&'));
  }
};

/**
 * 创建一个uuid
 * @param len 长度
 * @param radix  基数
 * @param prefix 前缀
 *
 */
export const uuid = (len?: number, radix?: number, prefix?: string): string => {
  const chars: string[] =
    '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid: string[] = [];
  let i: number = 0;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    let r: number = 0;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return prefix ? prefix + uuid.join('') : uuid.join('');
};

/**
 * 动态加载 script 脚本
 * @param scripts
 * @returns Promise
 */
export const loadScript = (scripts: string[] | string): Promise<boolean> => {
  if (!Array.isArray(scripts)) {
    scripts = [scripts];
  }
  let loaded: number = 0;
  const HEAD =
    document.getElementsByTagName('head').item(0) || document.documentElement;
  return new Promise((resolve, reject) => {
    try {
      for (let i: number = 0; i < scripts.length; i++) {
        const scriptNode = document.createElement('script');
        const scriptLoad = function (this: any) {
          if (
            !this.readyState ||
            this.readyState === 'loaded' ||
            this.readyState === 'complete'
          ) {
            loaded++;
            this.onload = this.onreadystatechange = null;
            this.parentNode.removeChild(this);
            if (loaded === scripts.length) {
              resolve(true);
            }
          }
        };
        scriptNode.setAttribute('type', 'text/javascript');
        scriptNode.setAttribute('src', scripts[i]);
        scriptNode.addEventListener('load', scriptLoad);
        scriptNode.addEventListener('readystatechange', scriptLoad);
        HEAD.appendChild(scriptNode);
      }
    } catch (e) {
      console.error(e);
      // eslint-disable-next-line prefer-promise-reject-errors
      reject(false);
    }
  });
};

/**
 * 串行加载 script
 * @param scripts
 */
export const loadScriptAwait = async (
  scripts: string[] | string
): Promise<boolean> => {
  if (!Array.isArray(scripts)) {
    scripts = [scripts];
  }
  try {
    for (let i: number = 0; i < scripts.length; i++) {
      const item = scripts[i];
      await loadScript(item);
    }
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * 动态加载 style
 * @param styles
 */
export const loadStyle = (styles: string | string[]):boolean => {
  if (!Array.isArray(styles)) {
    styles = [styles];
  }
  const HEAD =
    document.getElementsByTagName('head').item(0) || document.documentElement;
  for (let i: number = 0; i < styles.length; i++) {
    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = styles[i];
    HEAD.appendChild(link);
  }
  return true
};

export default {
  isIOS,
  isMac,
  isEdge,
  getSystem,
  getBrowser,
  isFileProtocol,
  copyText,
  getQueryParam,
  getQueryParamAll,
  setUrlParams,
  uuid,
  loadScript,
  loadScriptAwait,
  loadStyle,
  objectPath,
  shortid,
  // sha256,
  // md5,
  formatUtils,
  mathUtils,
  treeUtils
};
